
import { Component, Vue } from 'vue-property-decorator'
import router from '../../router'
import LoginModal from '../user/LoginModal.vue'

const request = {
  photos: [],
}
@Component({
  components: { LoginModal },
  props: ['response'],
})
export default class UploadFeedback extends Vue {
  photos = []
  request = request
  handleImage(e) {
    let file = e.target.files[0]
    this.onSelectedPhoto(file)
  }
  onSelectedPhoto(fileObject) {
    let reader = new FileReader()
    reader.onload = (event) => {
      let imageSrc = event.target.result
      this.photos.push(imageSrc)
    }
    reader.readAsDataURL(fileObject)
  }
  removePhoto(index) {
    this.photos.splice(index, 1)
    this.request.photos.splice(index, 1)
  }

  openFileInput() {
    ;(this.$refs.fileInput as HTMLInputElement).click()
  }
}
